//External libs
import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Subscription } from 'rxjs';

//Local libs
import Service from 'src/app/common/service';
import DeviceOnhandModel from './deviceOnhand.model';

@Injectable({
  providedIn: 'root'
})
export class DeviceOnhandService extends Service<DeviceOnhandModel> {

  public ongoingRequests: Subscription[] = [];

  constructor(public httpClient: HttpClient) {
    super(httpClient, '/aqu/deviceonhand/');
  }

  public getLocationData() {
    return new Promise<Array<DeviceOnhandModel>>((resolve, reject) => {
      const request = this.httpClient.get<Array<DeviceOnhandModel>>(`${this.baseUrl}${this.serviceUrl}getAllDeviceOnhand`, this.httpOptions).subscribe(response => {
        resolve(response);
      }, (error: HttpErrorResponse) => {
        reject(error);
      });
      this.ongoingRequests.push(request);
    });
  }

  //To Cancel the onGoing Http Requests
  public cancelOnGoingHttpRequests(): void {
    this.ongoingRequests.forEach((request) => {
      if (request && typeof request.unsubscribe === 'function') {
        request.unsubscribe();
      }
    });
    this.ongoingRequests = [];
  }
}
